import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import {
  addEvent,
  getEventById,
  updateEvent,
  uplaodMedia,
} from 'app/api/event';
import { getMallList } from 'app/api/mall';
import Message from 'app/utils/Message';
import {
  convertTo12HourFormat,
  convertTo24HourFormat,
  dataformatChangesYearToDate,
} from 'app/utils/Parsers';
import Toast from 'app/utils/Toast';
import {
  eventValidationRules,
  validate,
} from 'app/constants/validation-constants';

const useCreateEvent = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [mallList, setMallList] = useState([]);
  const [pageLoading, setPageLoading] = useState(false);
  const [error, setErrors] = useState({});
  const [values, setValues] = useState({
    name: '',
    headline: '',
    description: '',
    locationDetails: '',
    phone: '',
    mall_Id: null,
    coverImage: null,
    additionalImage: null,
    status: true,
    eventOpeningTime: '10:00',
    eventClosingTime: '17:00',
    startDate: null,
    // dataformatChangesYearToDate(temp),
    publish:false,
    endDate: null,
    url: '',
    secondaryUrl: '',
  });

  const eventId = location?.state?.id ? location?.state?.id : '';

  useEffect(() => {
    getMallListforDropdown();
    loadEventData(eventId);
  }, []);

  const getMallListforDropdown = async () => {
    setPageLoading(true);
    let response = await getMallList(1);
    setPageLoading(false);
    if (response && response.responseCode === 200) {
      let temp = response?.data?.malls?.map((item) => ({
        ...item,
        value: item.id,
        label: item.name,
      }));
      setMallList(temp);
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  };

  const loadEventData = async (id) => {
    if (!id) {
      return;
    }

    setPageLoading(true);
    let response = await getEventById(id);
    setPageLoading(false);

    if (response?.responseCode === 200) {
      let responsedata = response.data;

      setValues({
        ...responsedata,
        mall_Id: responsedata?.mallId?.id,
        startDate: dataformatChangesYearToDate(responsedata?.startDate),
        endDate: dataformatChangesYearToDate(responsedata?.endDate),
        eventOpeningTime: responsedata?.startTime
          ? convertTo24HourFormat(responsedata?.startTime)
          : '',
        eventClosingTime: responsedata?.endTime
          ? convertTo24HourFormat(responsedata?.endTime)
          : '',
      });
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  };

  const callAddOrUpdateAPI = async () => {
    setPageLoading(true);
    let response = {};

    let senddata = {
      ...values,
      startTime: convertTo12HourFormat(values.eventOpeningTime),
      endTime: convertTo12HourFormat(values.eventClosingTime),
    };

    if (eventId) {
      response = await updateEvent(eventId, { ...senddata });
    } else {
      response = await addEvent({ ...senddata });
    }

    setPageLoading(false);

    if (response?.responseCode === 200) {
      Toast.success(
        eventId
          ? Message.Events.UPDATED_SUCCESS
          : Message.Events.CREATED_SUCCESS
      );
      navigate(-1);
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  };

  const handleCreateEvent = (e) => {
    e.preventDefault();
    const validationErrors = validate(values, eventValidationRules);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      callAddOrUpdateAPI();
    }
  };

  const handleChange = (e) => {
    if (e && e.target) {
      const { name, value } = e.target;
      setValues((prevValues) => ({
        ...prevValues,
        [name]: name === 'phone' ? parseInt(value) : value,
      }));

      if (error[name]) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: '',
        }));
      }
    }
  };

  const setChange = (name, val) => {
    setValues((prevState) => ({
      ...prevState,
      [name]: val,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '',
    }));
  };

  const uploadMediaHandler = async (file, name) => {
    if (!file) {
      setChange(name, null);
      return;
    }

    const response = await uplaodMedia(file);
    if (response.responseCode === 200) {
      Toast.success('Image upload Successful');

      const data = response.data;
      setChange(name, data?.url);
    } else {
      Toast.error('Image upload failed');
    }
  };

  function handleTime(value, name) {
    setValues((prevValues) => {
      const newValues = { ...prevValues, [name]: value };

      if (
        name === 'eventOpeningTime' &&
        newValues.eventClosingTime &&
        new Date(`1970-01-01T${newValues.eventClosingTime}`) <=
          new Date(`1970-01-01T${value}`)
      ) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          eventClosingTime: 'Closing time must be after opening time.',
        }));
      } else if (
        name === 'eventClosingTime' &&
        newValues.eventOpeningTime &&
        new Date(`1970-01-01T${value}`) <=
          new Date(`1970-01-01T${newValues.eventOpeningTime}`)
      ) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          eventClosingTime: 'Closing time must be after opening time.',
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          eventClosingTime: '',
        }));
      }

      return newValues;
    });
    if (error[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: '',
      }));
    }
  }

  return {
    mallList,
    handleChange,
    values,
    error,
    setValues,
    handleCreateEvent,
    pageLoading,
    eventId,
    uploadMediaHandler,
    navigate,
    setChange,
    handleTime,
  };
};

export default useCreateEvent;
